export default {
    TeamMembers: [],
    SearchQuery: '',
    Teamfilters: [],
    Specfilters: [],
    SiteData:[]
}